<div class="rowContainer centeredFlex">
  <app-button type="tertiary" class="margin" value="{{globals.i18n.application.button.scrollToTop}}" (click)="scrollToTop()"></app-button>
</div>
